/**
 * Safe array utilities for handling unpredictable CMS data.
 */

/**
 * Ensures input is an array; returns empty array if not.
 */
export function ensureArray(value) {
  if (Array.isArray(value)) return value;
  if (value === null || value === undefined) return [];
  return [];
}

/**
 * Safe map operation - only maps if input is valid array.
 */
export function safeMap(value, mapFn) {
  const arr = ensureArray(value);
  return arr.map(mapFn);
}

/**
 * Safe array length check.
 */
export function safeLength(value) {
  return ensureArray(value).length;
}

/**
 * Check if value is non-empty array.
 */
export function isNonEmptyArray(value) {
  return Array.isArray(value) && value.length > 0;
}

/**
 * Safe array access with fallback.
 */
export function safeGet(array, index, fallback = null) {
  const arr = ensureArray(array);
  return arr[index] !== undefined ? arr[index] : fallback;
}

/**
 * Safely get nested property from object.
 */
export function safeGetProp(obj, prop, fallback = null) {
  if (!obj || typeof obj !== 'object') return fallback;
  return obj[prop] !== undefined ? obj[prop] : fallback;
}

/**
 * Ensure value is a string.
 */
export function ensureString(value, fallback = '') {
  if (typeof value === 'string') return value;
  if (value === null || value === undefined) return fallback;
  return String(value);
}

/**
 * Ensure value is a number.
 */
export function ensureNumber(value, fallback = 0) {
  if (typeof value === 'number' && !isNaN(value)) return value;
  const parsed = parseFloat(value);
  return isNaN(parsed) ? fallback : parsed;
}

